
/* Really just to be used in a direct binding into ng-style */
export interface ChartValuePosition {
    readonly left: string;
}

export function ValuePosition(value: number): ChartValuePosition {
    const leftPos = `${value}%`;
    return {left: leftPos};
}
